import { memo } from 'react';
import { Screen } from '@bonanza-social/navigation';
import CategoriesSkeleton from '../../components/Categories/Skeleton/CategoriesSkeleton';

function GamesScreenSkeleton() {
  return (
    <Screen paddingHorizontal="space-0">
      <CategoriesSkeleton />
    </Screen>
  );
}

export default memo(GamesScreenSkeleton);
